var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVcpNarrativesArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "41px",
    viewBox: "0 0 39 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0000888%",
    y1: "3.43391856e-08%",
    x2: "50.0000888%",
    y2: "100.000012%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB8C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB8C6",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0349423154,4.36850001 C0.100719315,4.53544001 0.246341315,4.64720001 0.410758315,4.67723001 C0.430702315,4.68600001 0.451305315,4.69351001 0.472469315,4.69964001 L5.09624432,12.4059 C5.23831432,12.6427 5.54544432,12.7195 5.78223432,12.5774 C6.01902432,12.4354 6.09581432,12.1282 5.95373432,11.8914 L1.67079432,4.75320001 C7.60692432,5.29466001 27.2823643,11.6343 38.0759643,41.0261 C38.1711643,41.2854 38.4584643,41.4183 38.7176643,41.3231 C38.9769643,41.2279 39.1098643,40.9406 39.0146643,40.6814 C28.5896643,12.2933 9.88246432,4.96332001 2.66552432,3.86942001 L10.0360643,0.965326014 C10.2929643,0.864096014 10.4191643,0.573759014 10.3179643,0.316841014 C10.2166643,0.0599222142 9.92636432,-0.0662881858 9.66946432,0.0349416142 L0.316841315,3.72002001 C0.0599213154,3.82125001 -0.0662886846,4.11158001 0.0349423154,4.36850001 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcpNarrativesArrow);
export default __webpack_public_path__ + "static/media/vcp-narratives-arrow.46882df62096550469ad80133a019f72.svg";
export { ForwardRef as ReactComponent };